<template>
  <div class="d-flex align-center" style="max-width: 220px">
    <v-text-field
      v-model="selectedMonth"
      type="month"
      density="compact"
      variant="outlined"
      hide-details
      base-color="white"
      theme="dark"
      style="min-width: 140px"
      @update:model-value="onMonthChange"
    >
      <template v-slot:append-inner>
        <v-icon
          :icon="currentPeriod?.is_closed ? 'mdi-lock' : 'mdi-lock-open'"
          :color="currentPeriod?.is_closed ? 'error' : 'success'"
          size="small"
        />
        <v-tooltip activator="parent" location="bottom">
          {{ currentPeriod?.is_closed ? "Period Closed" : "Period Open" }}
        </v-tooltip>
      </template>
    </v-text-field>
  </div>
</template>

<script setup>
import { usePettyCash } from "@/composables/usePettyCash.js";

const { selectedMonth, currentPeriod, activeView, fetchEntries, fetchPeriodStatus, fetchJournal, fetchLedger, fetchEmployeeBalances } = usePettyCash();

function onMonthChange() {
  fetchPeriodStatus();
  if (activeView.value === "journal") {
    fetchJournal();
  } else if (activeView.value === "ledger") {
    fetchLedger();
  } else if (activeView.value === "employees") {
    fetchEmployeeBalances();
  } else {
    fetchEntries();
  }
}
</script>
